export const getEnv = <T = string>(key: string, fallback?: string) =>
  ((process.env[key] as unknown) || fallback) as T;
